import { useEffect, useState, useRef, useCallback } from 'react'; // Import useRef and useCallback
import { useLocation } from "react-router-dom";
import SectionAccordanceView from './view';

export default function SectionAccordance(props: any) {
    const location = useLocation();
    const sourceComingFrom = location.state?.source;

    // Use useRef to track if the initial render logic has been applied
    const initialOpenHandled = useRef(false);

    const [openIndex, setOpenIndex] = useState('');

    const handleClick = (id: string) => {
        setOpenIndex(openIndex === id ? '' : id);
    };

    // Effect to handle initial opening based on sourceComingFrom
    useEffect(() => {
        if (sourceComingFrom && !initialOpenHandled.current) {
            // Find the detail that matches sourceComingFrom and set it as open
            const initialDetail = props.accordionDetails.find(
                (detail: any) => detail.keyForCode === sourceComingFrom
            );
            if (initialDetail) {
                setOpenIndex(initialDetail.section);
                initialOpenHandled.current = true; // Mark as handled
            }
        }
    }, [sourceComingFrom, props.accordionDetails]); // Dependencies for this effect

    // Determine if a section should be open based on the current openIndex state
    // This function is now much simpler and doesn't trigger state updates
    const getIsOpen = useCallback((detail: any) => {
        return openIndex === detail.section;
    }, [openIndex]);

    return (
        <>
            {props.accordionDetails.map((detail: any, index: number) => (
                <SectionAccordanceView
                    key={index}
                    detail={detail}
                    isOpen={getIsOpen(detail)} // Use the derived state
                    onClick={() => handleClick(detail.section)}
                    isLast={index === props.accordionDetails.length - 1}
                />
            ))}
        </>
    );
};